import { render, staticRenderFns } from "./ArgonModal.vue?vue&type=template&id=f2e7ef48&"
import script from "./ArgonModal.vue?vue&type=script&lang=js&"
export * from "./ArgonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports